import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUserInfo, canAccessMenu, getFirstAccessibleRoute } from '@/utils/auth';

// 不需要权限的公开路由
const publicRoutes = ['/login', '/reset-password', '/profile'];

// 路由守卫组件
export const RouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const userInfo = getUserInfo();
      
      // 如果是公开路由，直接通过
      if (publicRoutes.includes(location.pathname)) {
        setIsLoading(false);
        return;
      }

      // 如果用户未登录，跳转到登录页
      if (!userInfo || !userInfo.token) {
        navigate('/login');
        return;
      }

      // 如果用户已登录，但没有访问当前页面的权限
      if (!canAccessMenu(location.pathname)) {
        // 优先跳首页菜单；若首页菜单也无权，跳到第一个可访问的菜单路由；都没有则回登录页
        if (canAccessMenu('/homepage/news')) {
          navigate('/homepage/news');
        } else {
          const firstRoute = getFirstAccessibleRoute();
          navigate(firstRoute || '/login');
        }
        return;
      }

      setIsLoading(false);
    };

    checkAuth();
  }, [location.pathname, navigate]);

  // 加载状态，可以显示一个加载指示器
  if (isLoading) {
    // return <div className="flex items-center justify-center h-screen">加载中...</div>;
    return React.createElement(
      'div',
      { className: 'flex items-center justify-center h-screen' },
      '加载中...'
    );
  }

  return children;
};